import axios from 'axios';

const endpoints = {
    getSceneStateData: '/api/scene-state/get-serverless-scene-state-data',
    createModelState: '/api/model/create-model-state',
    getModelStateList: '/api/model/get-model-state-list',
    getModelStateData: '/api/model/get-serverless-model-state-data',
};

class SceneStateService {
    async getSceneStateData(payload) {
        const response = await axios.get(getAPIUrl() + endpoints.getSceneStateData, {
            params: payload
        });
        return response.data;
    }

    async createModelState(payload) {
        const response = await axios.post(getAPIUrl() + endpoints.createModelState, payload);
        return response.data;
    }

    async getModelStateList(payload) {
        const response = await axios.get(getAPIUrl() + endpoints.getModelStateList, {
            params: payload
        });
        return response.data;
    }

    async getModelStateData(payload) {
        const response = await axios.get(getAPIUrl() + endpoints.getModelStateData, {
            params: payload
        });
        return response.data;
    }
}

export default new SceneStateService();